import { MessageCircle } from "lucide-react";
import { toast } from "sonner";

export const WhatsAppCTA = () => (
    <section aria-label="WhatsApp contact" className="bg-teal-600 relative overflow-hidden">
        <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-center">
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                Have Questions About Your Dental Care?
            </h2>
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-teal-50 max-w-xl mx-auto">
                Chat with The Tooth Care Dental Clinic directly on WhatsApp.
            </p>
            <button
                type="button"
                data-testid="whatsapp-cta-chat-btn"
                onClick={() => toast.info("WhatsApp chat will be connected in the next update.")}
                className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-base font-semibold text-teal-700 shadow-[0_12px_30px_rgba(0,0,0,0.18)] transition-all duration-200 hover:bg-teal-50 hover:-translate-y-0.5"
            >
                <MessageCircle className="h-5 w-5" />
                Chat on WhatsApp
            </button>
        </div>
    </section>
);
